<script lang="ts" setup>
import { MenuItem } from '@headlessui/vue'
import { t } from '@/Support/lang'
import { computed } from 'vue'
import { iconClass, optionClass } from '@/Support/Styles/Global/Options'
import AppIcon from '@/Components/App/Global/AppIcon.vue'
import { ModelName } from '@/Support/Global/Interfaces/ModelName'

interface Props {
  enabled?: boolean
  iconActive?: boolean
  icon?: unknown
  clickValue?: string | number | boolean | null
  title: string
  translateTitle?: boolean
  iconName?: string
  iconSpin?: boolean
  activeIcon?: unknown
  activeIconName?: unknown
  activeTitleBold?: boolean
  appIcon?: string | ModelName
}

const props = withDefaults(defineProps<Props>(), {
  enabled: true,
  iconActive: false,
  clickValue: null,
  translateTitle: true,
  iconName: '',
  iconSpin: false,
})

const emit = defineEmits<{
  (e: 'clicked', value: string | number | boolean | null): void
}>()

const clicked = () => {
  if (props.enabled) {
    emit('clicked', props.clickValue)
  }
}

const cursorClass = computed(() => ({
  'cursor-pointer': props.enabled,
  'cursor-not-allowed': !props.enabled,
}))

const getIconClass = computed(() =>
  iconClass(props.iconActive, props.enabled, props.iconSpin),
)
</script>
<template>
  <MenuItem v-slot="{ active }" :class="cursorClass" :disabled="!enabled">
    <a :class="optionClass(enabled, active)" @click="clicked">
      <AppIcon v-if="appIcon" :icon="appIcon" mini :class="getIconClass" />
      <component
        v-else-if="activeIconName && iconActive"
        :is="activeIcon"
        :name="activeIconName"
        aria-hidden="true"
        :class="getIconClass"
      />
      <component
        v-else
        :is="icon"
        :name="iconName"
        aria-hidden="true"
        :class="getIconClass"
      />
      <span
        :class="{
          'opacity-50': !enabled,
          'font-semibold': activeTitleBold && iconActive,
        }"
      >
        {{ translateTitle ? t(title) : title }}
      </span>
    </a>
  </MenuItem>
</template>
